// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1KtRs","author":"Table_author__1GHVH","authorImage":"Table_authorImage__1DOuC","unreadRow":"Table_unreadRow__E7Ceo"};